import * as React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { Text } from '@notino/react-styleguide';
import { AvailabilityState } from '@notino/shared/definitions/types';

import { LOGIN_URL } from '@constants';
import { useProductDetailContext } from '@containers/ProductDetailContainer/ProductDetailContext';
import { useUser } from '@queries/useUser';

import { LoyaltySymbol } from './LoyaltySymbol';
import { CtaLink, LoyaltyProgramBannerWrapper } from './styled';

type Props = {
  productQuantity: number;
};

export const LoyaltyProgramBanner = ({ productQuantity }: Props) => {
  const { currentVariant } = useProductDetailContext();
  const { isLoggedIn } = useUser();
  const { formatNumber } = useIntl();

  const points = currentVariant.attributes.LoyaltyPoints;

  if (
    !points ||
    currentVariant.availability.state !== AvailabilityState.CanBeBought
  ) {
    return null;
  }

  return (
    <LoyaltyProgramBannerWrapper>
      <LoyaltySymbol />

      {isLoggedIn && (
        <Text typography="labelSmall400" color="text.secondary">
          <FormattedMessage
            id="product.loyalty.banner.pointsToEarnText"
            defaultMessage="You will earn <b>{points} points</b> from this purchase!"
            values={{
              b: (chunks) => (
                <Text typography="labelSmall" color="text.primary">
                  {chunks}
                </Text>
              ),
              points: formatNumber(points * productQuantity),
            }}
          />
        </Text>
      )}

      {!isLoggedIn && (
        <Text typography="labelSmall400" color="text.secondary">
          <FormattedMessage
            id="product.loyalty.banner.enrollText"
            defaultMessage="Don't miss out on rewards! Enroll into Loyalty program and start earning points & rewards. <link>CTA</link>"
            values={{
              link: (chunks) => (
                <CtaLink href={LOGIN_URL(currentVariant.url)}>{chunks}</CtaLink>
              ),
              points: formatNumber(points),
            }}
          />
        </Text>
      )}
    </LoyaltyProgramBannerWrapper>
  );
};
